/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getEtcInvoiceList, mappingToEtcInvoice } from '../../../apis/invoices';
import Button from '../../../components/Button';
import Filters from '../../../components/Filters';
import Modal, { ModalHeader } from '../../../components/Modal';
import { ControlTable } from '../../../components/Table';
import useForm from '../../../hooks/useForm';
import { getDay } from "../../../utils/date";
import { isEmpty } from '../../../utils/lodashExtend';
import { getParams } from '../../../utils/params';
import { autoHyphen } from '../../../utils/replace';
import systemAlert from '../../../utils/systemAlert';
import { toast } from '../../../utils/toast';

const EtcInvoiceMapping = ({
  open,
  setOpen,
  data,
  setData,
  type = "",
  requesterType,
  listSubmit,
  cashReceipt,
}) => {

  const history = useHistory();

  const cancel = () => {
    setData(null);
    setOpen(false);
  };

  const [filters] = useState([
    {
      isHide: type === "quotation" || type === "order",
      title: "구분", type: "select",
      key: "type",
      options: {
        list: [{
          label: "견적서",
          value: "quotation",
        },
        {
          label: "발주서",
          value: "order",
        }]
      }
    },
    { title: "조회기간 (작성일자)", key: "range.writeDate", type: "customdatepicker" },
    { title: "거래처명", key: 'search.byrCorpName' }
  ]);
  const [fields, setFields] = useState([]);
  const [title, setTitle] = useState("");
  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    type: type || "quotation",
    order: [{ writeDate: "desc" }],
    range: {
      writeDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
    },
    page: 0,
    limit: 10
  });

  useEffect(() => {
    setFields([
      { title: "종류", key: "etcInvoiceType", onValue: (value) => value === "quotation" ? "견적서" : "발주서" },
      { title: "작성일자", key: "writeDate", type: 'date' },
      { title: "상호", key: type === "quotation" ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: type === "quotation" ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: type === "quotation" ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      { title: "대표품목", key: "itemName" },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
    ]);
  }, [open]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [type]);



  const submit = (params) => {
    setIsLoading(true);
    getEtcInvoiceList(params.type, getParams(params)).then(res => {
      const { count, rows } = res.data;
      setTitle(params.type);
      setList(rows);
      setTotal(count);
    }).finally(() => setIsLoading(false));
  };

  const getServiceName = (requesterType) => {
    switch (requesterType) {
      case "quotation":
        return "견적서";
      case "order":
        return "발주서";
      case "taxInvoice":
        return "세금계산서";
      case "invoice":
        return "거래명세서";
      case "cashReceipt":
        return "현금영수증";
      default:
        break;
    }
  };


  const handleOnSupply = () => {
    const requester = getServiceName(requesterType);
    let body = {};

    switch (requesterType) {
      case "invoice":
      case "cashReceipt":
      case "taxInvoice":
        body = {
          list: selectedList.map(item => ({
            mappingIdx: data.idx,
            requestIdx: item.idx
          }))
        };

        if (!isEmpty(cashReceipt) && requesterType === "cashReceipt") {
          body.cashReceipt = cashReceipt;
        }
        systemAlert(`해당 ${requester}에 ${getServiceName(form.type)}를(을) 매핑 하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                mappingToEtcInvoice(requesterType, form.type, body).then(() => {
                  toast.success("매핑이 완료되었습니다.");
                  listSubmit();
                  cancel();
                });
              }
            }
          ]
        });
        break;

      default:
        body = {
          list: selectedList.map(item => ({
            requestIdx: data.idx,
            mappingIdx: item.idx
          }))
        };
        systemAlert(`해당 ${requester}에 ${getServiceName(form.type)}를(을) 매핑 하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                mappingToEtcInvoice(form.type, requesterType, body).then(() => {
                  toast.success("매핑이 완료되었습니다.");
                  listSubmit();
                  cancel();
                });
              }
            }
          ]
        });
        break;
    }


  };

  return (
    <>
      <Modal isOpen={open} close={cancel}>
        <div className="select-tax-invoice-container">
          <ModalHeader>{getServiceName(title)} 매핑하기</ModalHeader>
          <Filters
            isLoading={isLoading}
            filters={filters}
            submit={filterSubmit}
            form={form}
            onChange={handleOnChange} />
          <ControlTable
            isControl
            fields={fields}
            list={list}
            selectedList={selectedList}
            setSelected={setSelectedList}
            isLoading={isLoading}
            total={total}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            submit={handleSubmit}
          />
          <div className="submit-button-wrap float-right margin-top-32">
            <Button
              className="button"
              size="lg"
              label="취소"
              color="text"
              action={cancel}
            />
            <Button
              className="button"
              size="lg"
              label="적용하기"
              action={handleOnSupply}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EtcInvoiceMapping;